import moment from 'moment-jalaali';
export default function transformEvent(event) {
  const {
    agent_email,
    created,
    event_template: { title, extra = {}, slug },
  } = event;
  const momentDate = moment(created);
  const extraString = Object.values(extra).toString();
  return {
    creator: agent_email,
    date: momentDate,
    time: momentDate.format('H:mm'),
    title,
    description: extraString,
    slug,
  };
}
